module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#toc_2",
      "id": "cha_2"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he motor of the small wooden boat sputtered through mild waves as the stout man in his fifties sitting toward the front of its hull used his hairy arm to shield his eyes from the bright sunlight. A police shield was embroidered on his collared, short-sleeve shirt, and a black pistol holstered at his side gleamed as he motioned to the fisherman at the stern, whose help he’d commandeered, to ease back on the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They glided forward, past a few more pillars, until they slid under the shade of the deck of the bridge that hovered above. There, the familiar smell of brine and decaying sea life reminded the lawman of the creamed corn he’d had with his dinner the night before. Above the sporadic fuss of automobiles crossing overhead were the shouts of two young voices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Over here!” one of them yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The police chief looked up. Once the hot sun beat down on the boat again from the other side of the bridge, two pairs of thin arms waved from above, over the railing. The policeman’s eyes met the adolescent faces of two boys above, and he wondered which one had phoned in the finding. They both pointed downward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where ocean waves met freshwater marsh lay a dark object. Part of it was submerged in the water, while the rest—three or four feet in length—was propped up against a cluster of cattails straining at an angle from its weight. A half dozen seagulls paraded around the scene. They took flight as the boat approached.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“Chief Quammen?” called the man working the motor, probing for instruction.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shut it off,” the police chief replied in a New York accent. “And you may want to look away.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the engine petered, Quammen leaned forward and wrapped a meaty hand around a bundle of cattails. He pulled them in close and glared at the body they revealed. It was face down, with what was left of its mutilated skull and its lower torso draped across a dark blue surfboard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Quammen shook his head and took a deep breath. He leaned back on his heels, adjusted his belt, and raised his gaze back to the bridge. He spotted a young man—possibly a teenager—in a dark baseball cap and T-shirt, leaning across its railing about forty feet down from the boys. He had a thin build and a light complexion. With a fishing pole out over the banister, he was in the middle of adjusting his hat when he noticed Quammen staring up at him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Quammen held the man’s gaze for a moment before tightening his jaw and nodding in acknowledgement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Strands of wavy red hair dangling from below the rim of his cap blew around his face as the young man nodded back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Quammen turned his attention to the body in the cattails. The morning was going to be messy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8ec1e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 84
// module chunks = 0